import React,{useEffect} from "react";
import { useParams, useLocation } from 'react-router-dom';
import Header from "../pages/inc/Header";
import Footer from "../pages/inc/Footer";

import Body from "./Otherpage/Privacypolice";
import Popmodal from "../pages/inc/popmodal";
import Banner from "./About/Banner";

import { useTranslation } from 'react-i18next';



const Home = () => {
  const { t, i18n } = useTranslation()
  const { id } = useParams();
  const location = useLocation();
  let pathPrefix = location.pathname.split('/').length;
  let parameter_dat = id;
  if(pathPrefix > 2){
    pathPrefix = location.pathname.split('/')[0];
    pathPrefix = pathPrefix+'/';
  }
  let titleone_data;
  let lmg_data;
  let titletwo_data;
  let textone;
  let details_pargs;
 
    
      titleone_data = t("Privacy_Policy");
      titletwo_data = "";
      textone ='';
    
    
    const bannerdata = {
        titleone:titleone_data,
        titletwo:'',
        textone:'',
        texttwo:'',
        textthree:'',
        contentClass:'team-contents'
        
      };
         const { pathname } = useLocation();
            useEffect(() => {
              window.scrollTo(0, 0); 
            }, [pathname]); 
  return (   
    <>
    <Header/>
    <Banner bannerdata={bannerdata}/>
    <Body details_pargs={details_pargs} />
    <Footer/>
    <Popmodal/>
    </>
  );
};

export default Home;